// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__PyMi2","title":"Banner_title__68j0n","image":"Banner_image__SFhM8","button":"Banner_button__AOg3x","description":"Banner_description__rPE99"};